const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "31.1px",
    viewBox: "0 0 28 31.1",
    style: {
      enableBackground: "new 0 0 28 31.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M26.6,24.9c0.8,0,1.4-0.6,1.4-1.4v-17c0-1.9,0-3-0.5-4c-0.4-0.9-1.1-1.6-2-2c-1-0.5-2-0.5-4-0.5H6.5 c-1.9,0-3,0-4,0.5c-0.9,0.4-1.6,1.1-2,2C0,3.5,0,4.5,0,6.5v20.1c0,2.5,2,4.6,4.6,4.6h22c0.8,0,1.4-0.6,1.4-1.4 c0-0.8-0.6-1.4-1.4-1.4h-0.2v-3.5H26.6z M2.8,6.5c0-1.4,0-2.3,0.2-2.7C3.2,3.5,3.5,3.2,3.8,3C4.2,2.8,5,2.8,6.5,2.8h15.1 c1.4,0,2.3,0,2.7,0.2c0.3,0.2,0.6,0.4,0.8,0.8c0.2,0.4,0.2,1.2,0.2,2.7V22H4.6c-0.6,0-1.2,0.1-1.7,0.3V6.5z M23.6,28.3h-19 c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h19V28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M9.3,10.6h9.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4H9.3c-0.8,0-1.4,0.6-1.4,1.4S8.5,10.6,9.3,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M9.3,16.9h9.4c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4H9.3c-0.8,0-1.4,0.6-1.4,1.4 C7.9,16.3,8.5,16.9,9.3,16.9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.0d6f8ec8a72b20b278edaebd9e751b7d.svg";
export { ForwardRef as ReactComponent };